import { BetTypeGroup, MarketType, SportType } from '@/interface/enum';

export const NUMBER_OF_BET_TYPE_PER_ROW = 3;

export const NUMBER_OF_MAX_DISPLAYED_ODDS_BEFORE_EXPAND = 2;

const mainMarketConfig: Partial<Record<SportType, {
    live: MainMarketConfig[][];
    nonLive: MainMarketConfig[][];
}>> = {
    [SportType.Soccer]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.Cricket]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.GaelicFootball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.Hurling]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.Bandy]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.Others]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.ESports]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
            ],
        ],
    },
    [SportType.MotorSport]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
    },
    [SportType.Handball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
    },
    [SportType.BeachSoccer]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
    },
    [SportType.GeneralHockey]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
    },
    [SportType.AussieRulesFootball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
        ],
    },
    [SportType.Basketball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.OddEven },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Basketball_FirstHalfMoneyLine], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Basketball_FirstQuarter], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Football]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.AmericanFootball_FirstQuarter], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.AmericanFootball_FirstQuarter], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.AmericanFootball_FirstQuarter], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.IceHockey]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.IceHockey_FirstPeriod], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.IceHockey_SecondPeriod], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Baseball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Baseball_HomeTeamTotalRuns], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Baseball_AwayTeamTotalRuns], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Baseball_FirstInningRuns], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Baseball_FirstInningRuns], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Futsal]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Futsal_HomeTeamTotalGoal], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Futsal_AwayTeamTotalGoal], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Futsal_FirstHalf], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Futsal_HomeTeamTotalGoal], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Futsal_AwayTeamTotalGoal], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Tennis]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Tennis_SecondSet], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Tennis_SecondSet], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Tennis_SecondSet], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Tennis_GameHandicap], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Tennis_FirstSet], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Tennis_FirstSet], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Tennis_FirstSet], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Badminton]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Badminton_SecondSet], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Badminton_SecondSet], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Badminton_SecondSet], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Badminton_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Badminton_FirstSet], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Badminton_FirstSet], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Badminton_FirstSet], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.TableTennis]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            ],
            [
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.TableTennis_ThirdSetPointHandicap], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.TableTennis_ThirdSetPointHandicap], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.TableTennis_ThirdSetPointHandicap], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            ],
            [
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.TableTennis_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.TableTennis_FirstSetPointHandicap], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.TableTennis_FirstSetPointHandicap], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.TableTennis_FirstSetPointHandicap], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.Volleyball]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Volleyball_ThirdSetBetting], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Volleyball_ThirdSetBetting], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Volleyball_ThirdSetBetting], marketType: MarketType.OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.OverUnder },
                { betTypeGroups: [BetTypeGroup.Volleyball_TotalMatchPoints], marketType: MarketType.OddEven },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Volleyball_FirstSetBetting], marketType: MarketType.MoneyLine },
                { betTypeGroups: [BetTypeGroup.Volleyball_FirstSetBetting], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Volleyball_FirstSetBetting], marketType: MarketType.OverUnder },
            ],
        ],
    },
    [SportType.WaterPolo]: {
        live: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
        ],
        nonLive: [
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType._1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            ],
            [
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_1X2 },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
                { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            ],
        ],
    },
};

const defaultMainMarketConfig = {
    live: [
        [
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
        ],
        [
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
        ],
    ],
    nonLive: [
        [
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.OverUnder },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.MoneyLine },
        ],
        [
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_Handicap },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OverUnder },
            { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.FH_OddEven },
        ],
    ],
};

export type MainMarketConfig = {
    betTypeGroups: BetTypeGroup[];
    marketType: MarketType;
};

export function getMainMarketConfig(sportType: SportType, isLive: boolean): MainMarketConfig[][] {
    const liveKey = isLive ? 'live' : 'nonLive';
    return mainMarketConfig[sportType] === undefined ? defaultMainMarketConfig[liveKey] : mainMarketConfig[sportType][liveKey];
}
